import numeral from 'numeral'
import moment from 'moment'

export function formatCurrency (value: number | string): string {
  return numeral(parseFloat(String(value)).toFixed(2)).format('$0,0.00')
}

export function formatDateTime (datetime: Date | string | number): string {
  return moment(datetime).format('LLLL')
}
